import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AgGridI18nService {
    private translationLib: { [key: string]: string };

    constructor() {}

    public set agGridTranslationLib(lib: { [key: string]: string }) {
        this.translationLib = lib;
    }

    public get agGridTranslationLib(): { [key: string]: string } {
        return this.translationLib;
    }
}
